<template lang="html">
  <div id="products-results-page">

    <section class="products-section">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-12 col-title-s1">
            <h3 class="title">Equipos</h3>
          </div>

          <div class="col-12 col-products">
            <div class="row sample-products-wrapper xxl-5e">

              <div class="col-6 col-sm-6 col-md-4 col-lg-3 sample-product" v-for="product in products">
                <router-link class="outlined-box" :to="'/equipo/'+product.id">
                  <div class="box-image">
                    <div class="img">
                      <!-- <img :src="product.image_url"> -->
					  <api-img :comp="product.imagenes_id" />
                    </div>
                  </div>

                  <div class="box-shot-descr">
                    <h6 class="name">{{ product.nombre }}</h6>
                    <h6 class="modelo">{{ product.modelo }}</h6>
                    <!-- <h6 class="sku">{{ product.marca }}</h6> -->
                    <h6 class="brand">{{ product.marca }}</h6>
                    <h6 class="price">{{product.precio | currency}} MXN</h6>

                    <router-link class="btn-product" :to="'/equipo/'+product.id">Ver producto</router-link>
                  </div>
                </router-link>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>

  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex';
export default {
  name: 'ProductsIndex',
	data() {
		return {
			// products: [
			// 	{
			// 		id: 5,
			// 		image_url: "public/images/pages/products/product-1.jpg",
			// 		nombre: "Celular Samsung A12 5ta generación",
			// 	},
			// ],
		};
	},
	computed: {
		...mapGetters(['catalogosGetProductos']),
		products(){
			return _.filter(this.catalogosGetProductos, item => {
				console.debug(item)
				return true
			})
		}
	}
};
</script>
